/* eslint-disable import/prefer-default-export */
import { ResourceMap, ResourceOptionsV3 } from 'medialoopster/rest';

import { RootState } from '../../../types/rootState';
import { AssetCollection } from './types';

export const getAssetCollectionResourceMap = (
  state: RootState,
): ResourceMap<AssetCollection, ResourceOptionsV3> => state.rest.collection.objects;
